<template>
	<div class="container">
		<footer class="footer">
			<h3 class="footer--title">Come & find me!</h3>
			<ul class="list-inline">
				<li class="list-inline-item">
					<a href="https://github.com/andhikaribrahim" target="_blank" class="footer--icon"><i class="icon ion-logo-github"></i></a>
				</li>
				<li class="list-inline-item">
					<a href="https://www.facebook.com/andhikaribrahim" target="_blank" class="footer--icon"><i class="icon ion-logo-facebook"></i></a>
				</li>
				<li class="list-inline-item">
					<a href="https://twitter.com/r_ibrahimdika" target="_blank" class="footer--icon"><i class="icon ion-logo-twitter"></i></a>
				</li>
				<li class="list-inline-item">
					<a href="https://www.linkedin.com/in/andhikaribrahim/" target="_blank" class="footer--icon"><i class="icon ion-logo-linkedin"></i></a>
				</li>
			</ul>
		</footer>
	</div>
</template>

<script>
	export default {
		name: "Footer",
	}
</script>


// WEBPACK FOOTER //
// src/Components/Footer.vue